<script>
  export let siteLinks;
  import * as animateScroll from "svelte-scrollto";

</script>
<main>
  <!-- =============== Banner Section ================== -->
  <section id="banner">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h1 class="ordrk-banner-title" style="padding-top: 3rem;">Sell, Receive, Accept, Track, <br> Manage and Schedule deliveries</h1>
          <p class="ordrk-banner-para pb-3">ORDRK is a platform that gives you the ability to sell online, receive
            orders,
            accept payments, track sales, manage customers, and schedule deliveries.</p>
          <div class="row store">
            <a href="{siteLinks.PlayStore}" class="col-3 col-lg-3"><img src="assets/img/play-store.svg" alt=""></a>
            <a href="{siteLinks.AppStore}" class="col-3 offset-3 offset-md-2 offset-lg-1 offset-xl-0"><img src="assets/img/apple-store.svg"
                alt=""></a>
          </div>
        </div>
        <div class="col-md-4 text-center phone">
          <img class="" style="height: 488px;" src="assets/img/iphone12black_portrait.png" alt="iPhone">
        </div>
      </div>
    </div>
  </section>
  <!-- ================== Use Section ================ -->
  <section id="use">
    <div class="container">
      <h4 class="text-center section-title fw-bold">Why use ORDRK</h4>
      <div class="row justify-content-between" style="padding-top:3.9375rem;">

        <div class="col-md-3 why-use-card text-center mx-auto">
          <img class="img-fluid mt-4" src="assets/img/shopping-cart.svg" alt="Shopping Cart">
          <h4 class="use-col-title">Start selling online <br> in minutes
          </h4>
          <p class="use-col-des">Follow the <a href="#how-works" on:click={() => animateScroll.scrollTo({element: '#how-works', offset: -100})} >steps below </a>to<br> launch your shop in
            minutes.</p>
        </div>

        <div class="col-md-3 why-use-card text-center mx-auto">
          <img class="img-fluid mt-4" src="assets/img/income.svg" alt="Income">
          <h4 class="use-col-title">Accept payments online and offline</h4>
          <p class="use-col-des">Accept payments for orders <br> either by cash, bank transfer or <br>
            credit card(coming soon).</p>
        </div>

        <div class="col-md-3 why-use-card text-center mx-auto">
          <img class="img-fluid mt-4" src="assets/img/customer.svg" alt="">
          <h4 class="use-col-title">Keep track of customers</h4>
          <p class="use-col-des">Automatically generated list of customers with details and order history.</p>
        </div>

        <div class="col-md-3 why-use-card text-center mx-auto">
          <img class="img-fluid mt-4" src="assets/img/fast-delivery.svg" alt="">
          <h4 class="use-col-title">Multiple Delivery Options</h4>
          <p class="use-col-des">Give your customers the option to get their orders by delivery or pickup from your store.</p>
        </div>
      </div>
    </div>
  </section>
  <!-- ==================== Works Section ================== -->
  <section id="how-works" class="py-3">
    <div class="container pb-5">
      <h4 class="section-title text-center fw-bold pb-5">How it works</h4>
      <div class="row pb-3">
        <div class="col-md-6">
          <h5 class="mt-4 work-steps text-start"><img src="assets/img/one.svg" alt="" class="me-4">Download the app on
            your mobile</h5>
        </div>

        <div class="col-md-6">
          <h5 class="mt-4 work-steps text-start"><img src="assets/img/two.svg" alt="" class="me-4">Sign up and create
            a shop
          </h5>
        </div>
      </div>

      <div class="row pb-5">
        <div class="col-md-6">
          <h5 class="mt-4 work-steps text-start"><img src="assets/img/three.svg" alt="" class="me-4">Add Products to
            your shop</h5>
        </div>

        <div class="col-md-6">
          <h5 class="mt-4 work-steps text-start"><img src="assets/img/four.svg" alt="" class="me-4">Share your shop's
            link with
            your customers!</h5>
        </div>
      </div>

    </div>
  </section>
 </main>
 <style>
   main {
     margin-top: -36px;
   }
 </style>